<template>
  <div class="container reporte-ecp-container">
    <b-row>
      <b-container>
        <h3 class="text-center py-2">
          <b><i>{{ labels.title }}</i></b>
        </h3>

        <h5 class="text-center py-2">
          <b-row class="mb-4 justify-content-center align-items-end text-lg">
            <b-col md="auto" class="text-center px-3">
              <label class="d-block fw-bold fs-4 mb-3"><b>{{ labels.reporte }}:</b></label>
              <select v-model="selReporte" @change="handleChangeReporte"
                class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 200px;">
                <option value="">{{ labels.select }}...</option>
                <option v-for="reporte in listReportes" :key="reporte.codigo" :value="reporte.codigo">
                  {{ reporte.codigo }} - {{ reporte.nombre }}
                </option>
              </select>
            </b-col>

            <b-col md="auto" class="text-center px-3">
              <label class="d-block fw-bold fs-4 mb-3"><b>{{ labels.vigencia }}:</b></label>
              <select v-model="selVigencia" @change="handleChangeVigencia"
                class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 200px;">
                <option value="">{{ labels.select }}...</option>
                <option v-for="vigencia in listVigencias" :key="vigencia.vigencia" :value="vigencia.vigencia">
                  {{ vigencia.vigencia }}
                </option>
              </select>
            </b-col>

            <b-col md="auto" class="text-center px-3">
              <label class="d-block fw-bold fs-4 mb-3"><b>{{ labels.grupo }}:</b></label>
              <select v-model="grupoId" @change="filtrarCompaniesPorGrupo"
                class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 200px;">
                <option value="todos">{{ labels.allGroups }}</option>
                <option v-for="grupo in listGrupos" :key="'grupo-' + grupo.id" :value="grupo.id">
                  {{ grupo.nombre }}
                </option>
              </select>
            </b-col>

            <b-col md="auto" class="text-center px-3">
              <label class="d-block fw-bold fs-4 mb-3"><b>{{ labels.company }}:</b></label>
              <select v-model="companyId" @change="handleChangeCompany"
                class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 180px; max-width: 250px;">
                <option value="">{{ labels.select }}...</option>
                <option v-for="company in filteredCompanies" :key="company.id" :value="company.id">
                  {{ company.acronym ? company.acronym + ' ' : '' }}{{ company.nombre }}
                </option>
              </select>
            </b-col>
          </b-row>

          <b-row class="mb-4 justify-content-center align-items-center">
            <b-col md="auto" class="text-center">
              <b-button variant="primary" @click="consultarFilas" :disabled="!isFormValid"
                class="btn-lg px-5 mx-2 fs-5">
                <b><i>{{ labels.consultar }}</i></b>
              </b-button>
            </b-col>
          </b-row>
        </h5>
      </b-container>
    </b-row>

    <!-- Filas principales -->
    <b-row v-if="showFilas && !isLoading">
      <b-container>
        <div class="consolidation-section p-4 border rounded bg-light mt-4">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <label class="d-block fw-bold fs-5 mb-0 text-center flex-grow-1">
              <b>{{ labels.rows }}</b>
            </label>
            <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary"
              @click="abrirModalCrearFila" :disabled="isVigenciaBloqueada">
              <md-icon>add</md-icon>
            </md-button>
          </div>

          <div class="companies-checkbox-list" style="max-height: 400px; overflow-y: auto;">
            <div v-if="listFilasPrincipales.length === 0" class="text-center py-4">
              {{ labels.notRows }}
            </div>
            <div v-else>
              <div class="fila-item" v-for="fila in listFilasPrincipales" :key="fila.id" @click="seleccionarFila(fila)"
                :class="{ 'selected-item': filaSeleccionada && filaSeleccionada.id === fila.id }">
                <div class="d-flex justify-content-between align-items-center p-2">
                  <span class="fw-bold">{{ fila.orden }}.</span>
                  <span class="flex-grow-1 px-3">{{ fila.descripcion || '-' }}</span>
                  <div>
                    <md-button class="md-icon-button" style="color: #e5ac00;" @click.stop="editarFila(fila)"
                      :disabled="isVigenciaBloqueada">
                      <md-icon>edit</md-icon>
                    </md-button>
                    <md-button class="md-icon-button md-accent" @click.stop="eliminarFila(fila)"
                      :disabled="isVigenciaBloqueada">
                      <md-icon>delete</md-icon>
                    </md-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-container>
    </b-row>

    <!-- Loading spinner -->
    <b-row v-if="isLoading" class="mt-4">
      <b-col class="text-center py-5">
        <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
        <h4 class="text-primary mt-3"><b><i>{{ labels.loading }}</i></b></h4>
      </b-col>
    </b-row>

    <!-- Tabla de formulaciones -->
    <b-row v-if="filaSeleccionada && !isLoading">
      <b-container class="pb-5">
        <md-table v-model="listFormulaciones" md-card md-fixed-header class="balance-table principal-table">
          <md-table-toolbar>
            <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
              <div style="flex: 1; text-align: center;">
                <h1 class="md-title"><b><i>Detalle</i></b></h1>
              </div>
              <div style="display: flex; align-items: center; gap: 10px;">
                <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary"
                  @click="abrirModalCrearFormulacion" :disabled="isVigenciaBloqueada">
                  <md-icon>add</md-icon>
                </md-button>
              </div>
            </div>
          </md-table-toolbar>

          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell :md-label="labels.accounting">{{ getContable(item.contable) }}</md-table-cell>
            <md-table-cell :md-label="labels.current">{{ getActual(item.actual) }}</md-table-cell>
            <md-table-cell :md-label="labels.operation">{{ item.operacion }}</md-table-cell>
            <md-table-cell :md-label="labels.detail">
              <div v-if="item.contable == 1">
                <span v-if="item.cuentas">
                  <strong>{{ labels.accounts }}:</strong> {{ truncarTexto(item.cuentas, 40) }}
                </span>
                <span v-else-if="item.niif">
                  <strong>{{ labels.niifs }}:</strong> {{ truncarTexto(item.niif, 40) }}
                </span>
              </div>
              <div v-else>
                <strong>{{ getFormulacionTexto(item) }}</strong>
              </div>
            </md-table-cell>
            <md-table-cell :md-label="labels.edit">
              <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary"
                @click="editarFormulacion(item)" :disabled="isVigenciaBloqueada">
                <md-icon>edit</md-icon>
              </md-button>
            </md-table-cell>
            <md-table-cell :md-label="labels.delete">
              <md-button style="background-color: #cd2838; width: 35px; height: 35px;" class="md-fab md-primary"
                @click="eliminarFormulacion(item)" :disabled="isVigenciaBloqueada">
                <md-icon>delete</md-icon>
              </md-button>
            </md-table-cell>
          </md-table-row>

          <md-table-row slot="md-table-row" v-if="listFormulaciones.length === 0">
            <md-table-cell :md-label="labels.formulations" colspan="6" class="text-center">
              {{ labels.noFormulations }}
            </md-table-cell>
          </md-table-row>
        </md-table>
      </b-container>
    </b-row>

    <!-- Modal para crear/editar fila principal -->
    <md-dialog :md-active.sync="showModalFila" class="config-dialog">
      <md-dialog-title class="dialog-header-create">
        {{ isEditingFila ? labels.editRow : labels.createRow }}
      </md-dialog-title>

      <md-dialog-content>
        <div class="form-container">
          <div class="form-group">
            <label class="field-label required">{{ labels.order }}</label>
            <md-field>
              <md-input v-model="filaFormData.orden" type="number" min="1" required></md-input>
            </md-field>
          </div>

          <div class="form-group">
            <label class="field-label">{{ labels.description }}</label>
            <md-field>
              <md-input v-model="filaFormData.descripcion" maxlength="100"></md-input>
            </md-field>
          </div>
        </div>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-raised" @click="cerrarModalFila">{{ labels.cancel }}</md-button>
        <md-button class="md-raised md-primary" @click="guardarFila" :disabled="!filaFormData.orden || isVigenciaBloqueada">
          {{ labels.save }}
        </md-button>
      </md-dialog-actions>
    </md-dialog>

    <!-- Modal para crear/editar formulación -->
    <md-dialog :md-active.sync="showModalFormulacion" class="formulation-dialog">
      <md-dialog-title class="dialog-header-create">
        {{ isEditingFormulacion ? labels.editFormulation : labels.createFormulation }}
      </md-dialog-title>

      <md-dialog-content>
        <div class="form-container">
          <!-- Contable -->
          <div class="form-group">
            <label class="field-label required">{{ labels.accounting }}</label>
            <md-field>
              <md-select v-model="formulacionData.contable" @md-selected="cambiarTipoFormulacion">
                <md-option value="1">{{ labels.yes }}</md-option>
                <md-option value="0">{{ labels.no }}</md-option>
              </md-select>
            </md-field>
          </div>

          <!-- Actual -->
          <div class="form-group">
            <label class="field-label required">{{ labels.current }}</label>
            <md-field>
              <md-select v-model="formulacionData.actual">
                <md-option value="1">{{ labels.yes }}</md-option>
                <md-option value="0">{{ labels.no }}</md-option>
              </md-select>
            </md-field>
          </div>

          <!-- Operación -->
          <div class="form-group">
            <label class="field-label required">{{ labels.operation }}</label>
            <md-field>
              <md-select v-model="formulacionData.operacion">
                <md-option value="+">{{ labels.add }}</md-option>
                <md-option value="-">{{ labels.subtract }}</md-option>
              </md-select>
            </md-field>
          </div>

          <!-- Cuando es contable = 1 (Cuentas) -->
          <div v-if="formulacionData.contable === '1'">
            <div class="form-group">
              <label class="field-label">{{ labels.accounts }}</label>
              <div class="search-bar">
                <md-field class="search-field">
                  <md-input v-model="cuentasSearchTerm" :placeholder="labels.searchAccounts" @input="filtrarCuentas" />
                </md-field>
                <div class="selection-info">
                  {{ labels.selected }}: {{ formulacionData.cuentasSeleccionadas.length }}/{{ filteredCuentas.length }}
                </div>
              </div>

              <div class="cuenta-table-container">
                <table class="cuenta-table">
                  <thead>
                    <tr>
                      <th class="checkbox-column">
                        <md-checkbox :md-checked="selectAllCuentas" @change="toggleSelectAllCuentas" />
                      </th>
                      <th class="cuenta-column">{{ labels.accounts }}</th>
                      <th class="desc-column">{{ labels.description }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="cuenta in filteredCuentas" :key="cuenta.cuenta">
                      <td class="checkbox-column">
                        <md-checkbox v-model="cuenta._selected" @change="onCuentaCheckboxChange(cuenta)"
                          class="custom-checkbox" />
                      </td>
                      <td class="cuenta-column">{{ cuenta.cuenta }}</td>
                      <td class="desc-column" :title="cuenta.descripcion">{{ truncarTexto(cuenta.descripcion, 50) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-if="filteredCuentas.length === 0" class="no-results">{{ labels.noAccounts }}</div>
              </div>
            </div>
          </div>

          <!-- Cuando es contable = 0 (Formulación) -->
          <div v-if="formulacionData.contable === '0'">
            <div class="form-group">
              <label class="field-label required">{{ labels.formulation }}</label>
              <md-field>
                <md-select v-model="formulacionData.formulacion" @md-selected="cambiarFormulacion">
                  <md-option value="m">{{ labels.manual }}</md-option>
                  <md-option value="sf">{{ labels.sumRow }}</md-option>
                  <md-option value="n">{{ labels.niif }}</md-option>
                </md-select>
              </md-field>
            </div>

            <!-- Suma Fila -->
            <div v-if="formulacionData.formulacion === 'sf'" class="form-group">
              <label class="field-label">{{ labels.rowToSum }}</label>
              <md-field>
                <md-input v-model="formulacionData.sumFila" type="text" placeholder="Ej: 1,2,3"></md-input>
              </md-field>
            </div>

            <!-- NIIF específico para formulación -->
            <div v-if="formulacionData.formulacion === 'n'" class="form-group">
              <label class="field-label">{{ labels.selectNiifFormulation }}</label>
              <div class="search-bar">
                <md-field class="search-field">
                  <md-input v-model="niifsSearchTerm" :placeholder="labels.searchNiifs" @input="filtrarNiifs" />
                </md-field>
                <div class="selection-info">
                  {{ labels.selected }}: {{ formulacionData.niifFormulacion.length }}/{{ filteredNiifs.length }}
                </div>
              </div>

              <div class="niif-table-container">
                <table class="niif-table">
                  <thead>
                    <tr>
                      <th class="checkbox-column">
                        <md-checkbox :md-checked="selectAllNiifs" @change="toggleSelectAllNiifs" />
                      </th>
                      <th class="niif-column">NIIF</th>
                      <th class="desc-column">{{ labels.description }}</th>
                      <th class="level-column">Nivel 1</th>
                      <th class="level-desc-column">Desc. Nivel 1</th>
                      <th class="level-column">Nivel 2</th>
                      <th class="level-desc-column">Desc. Nivel 2</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="niif in filteredNiifs" :key="niif.niif">
                      <td class="checkbox-column">
                        <md-checkbox v-model="niif._selected" @change="onNiifCheckboxChange(niif)"
                          class="custom-checkbox" />
                      </td>
                      <td class="niif-column">{{ niif.niif }}</td>
                      <td class="desc-column" :title="niif.nameNiif || niif.descripcion">{{ truncarTexto(niif.nameNiif
                        || niif.descripcion, 40) }}</td>
                      <td class="level-column">{{ niif.primer_nivel || '-' }}</td>
                      <td class="level-desc-column" :title="niif.namePrimerNivel">{{ truncarTexto(niif.namePrimerNivel
                        || '-', 30) }}</td>
                      <td class="level-column">{{ niif.segundo_nivel || '-' }}</td>
                      <td class="level-desc-column" :title="niif.nameSegundoNivel">{{ truncarTexto(niif.nameSegundoNivel
                        || '-', 30) }}</td>
                    </tr>
                  </tbody>
                </table>
                <div v-if="filteredNiifs.length === 0" class="no-results">{{ labels.noNiifs }}</div>
              </div>
            </div>
          </div>
        </div>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-raised" @click="cerrarModalFormulacion">{{ labels.cancel }}</md-button>
        <md-button class="md-raised md-primary" @click="guardarFormulacion" :disabled="!isFormulacionValid || isVigenciaBloqueada">
          {{ labels.save }}
        </md-button>
      </md-dialog-actions>
    </md-dialog>

    <!-- Modal para eliminar -->
    <md-dialog :md-active.sync="showDeleteModal">
      <md-dialog-title>{{ labels.confirmDelete }}</md-dialog-title>
      <md-dialog-content>{{ labels.deleteMessage }}</md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-raised" @click="showDeleteModal = false">{{ labels.cancel }}</md-button>
        <md-button class="md-raised md-accent" @click="confirmarEliminacion" :disabled="isVigenciaBloqueada">{{ labels.delete }}</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import Balance from '../../services/BalanceNiif';
import PlanCuentas from '../../services/PlanCuentas';
import Company from '../../services/Company';
import Grupo from '../../services/Grupo';
import PlanConsolidacion from '../../services/PlanConsolidacion';

export default {
  name: 'OriConfiguracion',
  props: {
    userId: {
      type: Number,
      default: () => {
        const stored = localStorage.getItem('userId');
        return stored ? parseInt(stored) : null;
      }
    }
  },
  data() {
    return {
      selReporte: '',
      selReporteAnterior: '',
      selVigencia: '',
      selVigenciaAnterior: '',
      grupoId: 'todos',
      companyId: '',
      companyIdAnterior: '',

      listReportes: [],
      listVigencias: [],
      listGrupos: [],
      listCompanies: [],
      filteredCompanies: [],
      companiaUsuario: [],

      listFilasPrincipales: [],
      filaSeleccionada: null,
      showFilas: false,

      listFormulaciones: [],

      isLoading: false,
      showModalFila: false,
      showModalFormulacion: false,
      showDeleteModal: false,
      isEditingFila: false,
      isEditingFormulacion: false,
      elementoAEliminar: null,
      tipoEliminacion: null,

      cuentasDisponibles: [],
      filteredCuentas: [],
      niifsDisponibles: [],
      filteredNiifs: [],
      listNiifsDisponibles: [],

      cuentasSearchTerm: '',
      niifsSearchTerm: '',

      selectAllCuentas: false,
      selectAllNiifs: false,

      filaFormData: {
        id: null,
        orden: null,
        descripcion: ''
      },

      formulacionData: {
        id: null,
        orden: null,
        contable: '1',
        actual: '1',
        operacion: '+',
        cuentasSeleccionadas: [],
        formulacion: 'm',
        sumFila: '',
        sumColumna: '',
        celdaFila: '',
        celdaColumna: '',
        niifFormulacion: []
      }
    };
  },
  computed: {
    isVigenciaBloqueada() {
      return this.selVigencia ? !this.$store.getters.isPeriodoEnabled(this.selVigencia) : false
    },
    labels() {
      const es = this.$store?.state?._language === 'es-ES';
      return {
        title: es ? 'Configuración Reporte ORI' : 'ORI Report Configuration',
        reporte: es ? 'Reporte' : 'Report',
        vigencia: es ? 'Vigencia' : 'Validity',
        grupo: es ? 'Grupo' : 'Group',
        company: es ? 'Compañía' : 'Company',
        select: es ? 'Seleccione' : 'Select',
        allGroups: es ? 'Todos los grupos' : 'All groups',
        consultar: es ? 'Consultar' : 'Consult',
        addRow: es ? 'Añadir Fila' : 'Add Row',
        rows: es ? 'Filas Configuradas' : 'Configured Rows',
        notRows: es ? 'No hay filas configuradas' : 'No configured rows',
        loading: es ? 'Cargando información...' : 'Loading information...',
        formulationsFor: es ? 'Formulaciones para' : 'Formulations for',
        addFormulation: es ? 'Añadir Formulación' : 'Add Formulation',
        formulations: es ? 'Formulaciones' : 'Formulations',
        noFormulations: es ? 'No hay formulaciones para esta fila' : 'No formulations for this row',
        createRow: es ? 'Crear Fila' : 'Create Row',
        editRow: es ? 'Editar Fila' : 'Edit Row',
        createFormulation: es ? 'Crear Formulación' : 'Create Formulation',
        editFormulation: es ? 'Editar Formulación' : 'Edit Formulation',
        order: es ? 'Orden' : 'Order',
        description: es ? 'Descripción' : 'Description',
        accounting: es ? 'Contable' : 'Accounting',
        nonAccounting: es ? 'No Contable' : 'Non Accounting',
        yes: es ? 'Sí' : 'Yes',
        no: es ? 'No' : 'No',
        current: es ? 'Actual' : 'Current',
        previous: es ? 'Anterior' : 'Previous',
        operation: es ? 'Operación' : 'Operation',
        add: es ? 'Suma' : 'Add',
        subtract: es ? 'Resta' : 'Subtract',
        selectAccountsOrNiifs: es ? 'Seleccionar' : 'Select',
        accounts: es ? 'Cuentas' : 'Accounts',
        niifs: es ? 'NIIFs' : 'IFRS',
        searchAccounts: es ? 'Buscar cuentas...' : 'Search accounts...',
        searchNiifs: es ? 'Buscar NIIFs...' : 'Search IFRS...',
        selectAll: es ? 'Seleccionar todas' : 'Select all',
        accountsSelected: es ? 'cuenta(s) seleccionada(s)' : 'account(s) selected',
        niifsSelected: es ? 'NIIF(s) seleccionado(s)' : 'IFRS(s) selected',
        noAccounts: es ? 'No se encontraron cuentas' : 'No accounts found',
        noNiifs: es ? 'No se encontraron NIIFs' : 'No IFRS found',
        formulation: es ? 'Formulación' : 'Formulation',
        manual: es ? 'Manual' : 'Manual',
        sumRow: es ? 'Suma Fila' : 'Sum Row',
        sumColumn: es ? 'Suma Columna' : 'Sum Column',
        cell: es ? 'Celda' : 'Cell',
        niif: es ? 'NIIF' : 'IFRS',
        rowToSum: es ? 'Fila(s) a sumar' : 'Row(s) to sum',
        columnToSum: es ? 'Columna(s) a sumar' : 'Column(s) to sum',
        rowCell: es ? 'Fila' : 'Row',
        columnCell: es ? 'Columna' : 'Column',
        selectNiifFormulation: es ? 'Seleccionar NIIF' : 'Select IFRS',
        cancel: es ? 'Cancelar' : 'Cancel',
        save: es ? 'Guardar' : 'Save',
        confirmDelete: es ? 'Confirmar Eliminación' : 'Confirm Delete',
        deleteMessage: es ? '¿Está seguro de eliminar este elemento?' : 'Are you sure you want to delete this item?',
        delete: es ? 'Eliminar' : 'Delete',
        detail: es ? 'Detalle' : 'Detail',
        edit: es ? 'Editar' : 'Edit'
      };
    },

    isFormValid() {
      return this.selReporte && this.selVigencia && this.companyId;
    },

    isFormulacionValid() {
      if (!this.formulacionData.contable) return false;
      if (!this.formulacionData.actual) return false;
      if (!this.formulacionData.operacion) return false;

      if (this.formulacionData.contable === '1') {
        if (this.formulacionData.cuentasSeleccionadas.length === 0) {
          return false;
        }
      }

      if (this.formulacionData.contable === '0' && !this.formulacionData.formulacion) {
        return false;
      }

      return true;
    }
  },

  watch: {
    cuentasSearchTerm() {
      this.filtrarCuentas();
    },
    niifsSearchTerm() {
      this.filtrarNiifs();
    },
    selReporte(valNew) {
      if (valNew !== this.selReporteAnterior) {
        this.resetSeleccion();
        this.selReporteAnterior = valNew;
      }
    },
    selVigencia(valNew) {
      if (valNew !== this.selVigenciaAnterior) {
        this.resetSeleccion();
        this.selVigenciaAnterior = valNew;
        if (this.isVigenciaBloqueada) {
          this.$toast?.error('La vigencia seleccionada está deshabilitada para crear o editar');
        }
      }
    },
    companyId(valNew) {
      if (valNew !== this.companyIdAnterior) {
        this.resetSeleccion();
        this.companyIdAnterior = valNew;
      }
    }
  },

  methods: {
    getContable(valContable) {
      return valContable == 1 ? 'Sí' : 'No';
    },

    getActual(valActual) {
      return valActual == 1 ? 'Sí' : 'No';
    },

    handleChangeReporte() {
      this.resetSeleccion();
    },

    handleChangeVigencia() {
      this.resetSeleccion();
    },

    handleChangeCompany() {
      this.resetSeleccion();
    },

    resetSeleccion() {
      this.showFilas = false;
      this.listFilasPrincipales = [];
      this.filaSeleccionada = null;
      this.listFormulaciones = [];
    },

    filtrarCompaniesPorGrupo() {
      this.companyId = '';
      this.resetSeleccion();

      if (this.grupoId === 'todos' || !this.grupoId) {
        this.filteredCompanies = [...this.listCompanies];
      } else {
        const grupoIdStr = this.grupoId.toString();
        this.filteredCompanies = this.listCompanies.filter(company => {
          if (!company.id_grupos) return false;
          const gruposCompania = company.id_grupos.split(',').map(id => id.trim());
          return gruposCompania.includes(grupoIdStr);
        });
      }
    },

    async consultarFilas() {
      if (!this.isFormValid) {
        this.$toast?.warning('Complete todos los campos');
        return;
      }

      this.isLoading = true;

      try {
        const response = await Balance.obtenerFilasPrincipalesOri(
          this.selReporte,
          this.companyId,
          this.selVigencia
        );

        let datos = response.data.data || [];

        // Transformar si viene como objeto anidado con índices numéricos
        if (datos.length > 0 && typeof datos[0] === 'object' && !Array.isArray(datos[0])) {
          const primerElemento = datos[0];
          const valores = Object.values(primerElemento);
          datos = valores.filter(item => item && item.id);
        }

        if (datos.length === 1 && typeof datos[0] === 'object' && !Array.isArray(datos[0])) {
          const posiblesFilas = Object.values(datos[0]).filter(item => item && item.id);
          if (posiblesFilas.length > 0) {
            datos = posiblesFilas;
          }
        }

        // Si no hay filas, intentar copiar solo una vez
        if (datos.length === 0) {
          // Usar una variable para evitar loops infinitos
          if (!this._intentandoCopiar) {
            this._intentandoCopiar = true;

            const añoActual = parseInt(this.selVigencia.substring(0, 4));
            const mes = this.selVigencia.substring(4, 6);
            const vigenciaAnterior = `${añoActual - 1}${mes}`;

            const userId = this.userId || this.$store?.state?.userId || localStorage.getItem('userId');

            // Verificar si existe configuración en la vigencia anterior
            const responseAnterior = await Balance.obtenerFilasPrincipalesOri(
              this.selReporte,
              this.companyId,
              vigenciaAnterior
            );

            let datosAnterior = responseAnterior.data.data || [];

            if (datosAnterior.length > 0 && typeof datosAnterior[0] === 'object' && !Array.isArray(datosAnterior[0])) {
              const primerElemento = datosAnterior[0];
              const valores = Object.values(primerElemento);
              datosAnterior = valores.filter(item => item && item.id);
            }

            // Solo copiar si hay datos en la vigencia anterior
            if (datosAnterior.length > 0) {
              await Balance.copiarConfiguracionOri(
                this.selReporte,
                this.companyId,
                vigenciaAnterior,
                this.selVigencia,
                userId
              );

              this.$toast?.success(`Configuración copiada desde vigencia ${vigenciaAnterior}`);

              // Volver a consultar después de copiar
              this._intentandoCopiar = false;
              await this.consultarFilas();
              return;
            } else {
              this.$toast?.info(`No hay configuración en la vigencia anterior ${vigenciaAnterior}`);
            }

            this._intentandoCopiar = false;
          }
        }

        this.listFilasPrincipales = datos;
        this.showFilas = true;
        this.filaSeleccionada = null;
        this.listFormulaciones = [];

        if (this.listFilasPrincipales.length === 0) {
          this.$toast?.info('No hay filas configuradas para esta combinación. Puede agregar filas usando el botón +');
        } else {
          this.$toast?.success(`Se encontraron ${this.listFilasPrincipales.length} filas`);
        }

      } catch (error) {
        console.error('Error consultando filas:', error);
        this.$toast?.error('Error al consultar las filas');
      } finally {
        this.isLoading = false;
        delete this._intentandoCopiar;
      }
    },

    async seleccionarFila(fila) {
      console.log('Fila seleccionada:', fila);
      this.filaSeleccionada = fila;

      // Asegurarse que orden es un número
      const ordenFila = parseInt(fila.orden);

      if (isNaN(ordenFila)) {
        console.error('Orden de fila inválido:', fila.orden);
        this.$toast?.error('Error: Orden de fila inválido');
        return;
      }

      await this.cargarFormulaciones(ordenFila);
    },

    async cargarFormulaciones(ordenFila) {
      console.log('Cargando formulaciones para orden_fila:', ordenFila);

      if (!ordenFila || isNaN(ordenFila)) {
        console.error('orden_fila inválido:', ordenFila);
        this.$toast?.error('Error: Orden de fila inválido');
        return;
      }

      this.isLoading = true;

      try {
        const response = await Balance.obtenerFormulacionesOri(
          this.selReporte,
          this.companyId,
          this.selVigencia,
          ordenFila  // Asegurar que es un número, no undefined
        );

        this.listFormulaciones = response.data.data || [];
        console.log('Formulaciones cargadas:', this.listFormulaciones.length);

      } catch (error) {
        console.error('Error cargando formulaciones:', error);
        this.listFormulaciones = [];
        this.$toast?.error('Error al cargar las formulaciones');
      } finally {
        this.isLoading = false;
      }
    },

    editarFila(fila) {
      if (this.isVigenciaBloqueada) {
        this.$toast?.error('La vigencia seleccionada está deshabilitada para crear o editar');
        return;
      }
      this.isEditingFila = true;
      this.filaFormData = {
        id: fila.id,
        orden: fila.orden,
        descripcion: fila.descripcion || ''
      };
      this.showModalFila = true;
    },


    async guardarFila() {
      if (this.isVigenciaBloqueada) {
        this.$toast?.error('La vigencia seleccionada está deshabilitada para crear o editar');
        return;
      }
      if (!this.filaFormData.orden) {
        this.$toast?.warning('El orden es obligatorio');
        return;
      }

      const userId = this.userId || this.$store?.state?.userId || localStorage.getItem('userId');

      if (!userId) {
        this.$toast?.error('No se encontró el ID de usuario');
        return;
      }

      this.isLoading = true;

      try {
        const payload = {
          accion: this.isEditingFila ? 'UPDATE_FILA_PRINCIPAL' : 'INSERT_FILA_PRINCIPAL',
          id: this.filaFormData.id || null,
          codReporte: parseInt(this.selReporte),
          vigencia: this.selVigencia,
          id_compania: parseInt(this.companyId),
          orden: parseInt(this.filaFormData.orden),
          descripcion: this.filaFormData.descripcion || null,
          u_crea: parseInt(userId),
          u_modifica: parseInt(userId)
        };

        await Balance.gestionarFilasPrincipalesOri(payload);

        this.$toast?.success(this.isEditingFila ? 'Fila actualizada' : 'Fila creada');
        this.cerrarModalFila();
        await this.consultarFilas();

      } catch (error) {
        console.error('Error guardando fila:', error);
        this.$toast?.error(error.response?.data?.message || 'Error al guardar');
      } finally {
        this.isLoading = false;
      }
    },

    async abrirModalCrearFormulacion() {
      if (this.isVigenciaBloqueada) {
        this.$toast?.error('La vigencia seleccionada está deshabilitada para crear o editar');
        return;
      }
      if (!this.filaSeleccionada) {
        this.$toast?.warning('Seleccione una fila primero');
        return;
      }

      this.isEditingFormulacion = false;
      await this.cargarCuentasYNiifs();

      // Resetear todos los valores a su estado inicial (NO seleccionados)
      this.formulacionData = {
        id: null,
        orden: this.filaSeleccionada.orden,
        contable: '1',     // "Sí" por defecto
        actual: '1',       // "Sí" por defecto
        operacion: '+',
        cuentasSeleccionadas: [],
        formulacion: 'm',
        sumFila: '',
        sumColumna: '',
        celdaFila: '',
        celdaColumna: '',
        niifFormulacion: []
      };

      this.selectAllCuentas = false;
      this.cuentasSearchTerm = '';
      this.filtrarCuentas();

      this.showModalFormulacion = true;
    },

    abrirModalCrearFila() {
      if (this.isVigenciaBloqueada) {
        this.$toast?.error('La vigencia seleccionada está deshabilitada para crear o editar');
        return;
      }
      this.isEditingFila = false;
      this.filaFormData = {
        id: null,
        orden: null,
        descripcion: ''
      };
      this.showModalFila = true;
    },

    async editarFormulacion(formulacion) {
      if (this.isVigenciaBloqueada) {
        this.$toast?.error('La vigencia seleccionada está deshabilitada para crear o editar');
        return;
      }
      const formulacionClone = JSON.parse(JSON.stringify(formulacion));

      this.isEditingFormulacion = true;

      // Primero cargar cuentas y NIIFs
      await this.cargarCuentasYNiifs();

      if (formulacionClone.contable == 1) {
        // Para contable = 1 (Cuentas)
        const cuentasSeleccionadasArray = formulacionClone.cuentas ? formulacionClone.cuentas.split(',') : [];

        // Marcar las cuentas seleccionadas DESPUÉS de cargar los datos
        this.cuentasDisponibles.forEach(cuenta => {
          cuenta._selected = cuentasSeleccionadasArray.includes(cuenta.cuenta);
        });

        this.formulacionData = {
          id: formulacionClone.id,
          orden: this.filaSeleccionada.orden,
          contable: '1',
          actual: formulacionClone.actual !== undefined && formulacionClone.actual !== null
            ? formulacionClone.actual.toString()
            : '1',
          operacion: formulacionClone.operacion || '+',
          cuentasSeleccionadas: cuentasSeleccionadasArray,
          formulacion: 'm',
          sumFila: '',
          sumColumna: '',
          celdaFila: '',
          celdaColumna: '',
          niifFormulacion: []
        };

      } else {
        // Para contable = 0 (Formulación)
        let formulacionTipo = 'm';
        let sumFila = '';
        let sumColumna = '';
        let celdaFila = '';
        let celdaColumna = '';
        let niifFormulacionArray = [];

        if (formulacionClone.formulacion) {
          if (formulacionClone.formulacion.startsWith('sf:')) {
            formulacionTipo = 'sf';
            sumFila = formulacionClone.formulacion.substring(3);
          } else if (formulacionClone.formulacion.startsWith('n:')) {
            formulacionTipo = 'n';
            // Extraer los NIIFs del string
            niifFormulacionArray = formulacionClone.formulacion.substring(2).split(',');

            // Limpiar espacios en blanco y filtrar valores vacíos
            niifFormulacionArray = niifFormulacionArray
              .map(n => n.trim())
              .filter(n => n !== '');

            // IMPORTANTE: Marcar los NIIFs seleccionados DESPUÉS de cargar los datos
            // Esperar un tick para asegurar que niifsDisponibles está cargado
            await this.$nextTick();

            console.log('NIIFs a seleccionar:', niifFormulacionArray);
            console.log('NIIFs disponibles:', this.niifsDisponibles.map(n => n.niif));

            // Marcar los NIIFs seleccionados
            this.niifsDisponibles.forEach(niif => {
              niif._selected = niifFormulacionArray.includes(niif.niif.toString());
              console.log(`NIIF ${niif.niif}: ${niif._selected}`);
            });
          }
        }

        this.formulacionData = {
          id: formulacionClone.id,
          orden: this.filaSeleccionada.orden,
          contable: '0',
          actual: formulacionClone.actual !== undefined && formulacionClone.actual !== null
            ? formulacionClone.actual.toString()
            : '1',
          operacion: formulacionClone.operacion || '+',
          cuentasSeleccionadas: [],
          formulacion: formulacionTipo,
          sumFila: sumFila,
          sumColumna: sumColumna,
          celdaFila: celdaFila,
          celdaColumna: celdaColumna,
          niifFormulacion: niifFormulacionArray
        };
      }

      // Actualizar filteredCuentas y filteredNiifs con los _selected correctos
      this.filtrarCuentas();
      this.filtrarNiifs();

      // Actualizar selectAll
      this.updateSelectAllCuentas();
      this.updateSelectAllNiifs();

      this.showModalFormulacion = true;
    },

    async guardarFormulacion() {
      if (this.isVigenciaBloqueada) {
        this.$toast?.error('La vigencia seleccionada está deshabilitada para crear o editar');
        return;
      }
      if (!this.isFormulacionValid) {
        this.$toast?.warning('Complete los campos requeridos');
        return;
      }

      const userId = this.userId || this.$store?.state?.userId || localStorage.getItem('userId');

      if (!userId) {
        this.$toast?.error('No se encontró el ID de usuario');
        return;
      }

      this.isLoading = true;

      try {
        let cuentasFinal = null;
        let niifFinal = null;
        let formulacionFinal = '';

        if (this.formulacionData.contable === '1') {
          // Para contable = 1, solo cuentas, formulacion vacío
          cuentasFinal = this.formulacionData.cuentasSeleccionadas.join(',');
          formulacionFinal = '';  // ← Cadena vacía, no null
        } else {
          // Construir la formulación según el tipo (contable = 0)
          if (this.formulacionData.formulacion === 'sf') {
            formulacionFinal = `sf:${this.formulacionData.sumFila}`;
          } else if (this.formulacionData.formulacion === 'n') {
            formulacionFinal = `n:${this.formulacionData.niifFormulacion.join(',')}`;
          } else {
            formulacionFinal = 'm';
          }
        }

        const payload = {
          accion: this.isEditingFormulacion ? 'UPDATE_FORMULACION' : 'INSERT_FORMULACION',
          id: this.formulacionData.id || null,
          codReporte: parseInt(this.selReporte),
          vigencia: this.selVigencia,
          id_compania: parseInt(this.companyId),
          orden: parseInt(this.formulacionData.orden),
          reporte: 'ORI',
          niif: niifFinal,
          cuentas: cuentasFinal,
          contable: parseInt(this.formulacionData.contable),
          actual: parseInt(this.formulacionData.actual),
          operacion: this.formulacionData.operacion,
          formulacion: formulacionFinal,
          valor: 0,
          u_crea: parseInt(userId),
          u_modifica: parseInt(userId)
        };

        console.log('Payload enviado:', payload);

        await Balance.gestionarFormulacionesOri(payload);

        this.$toast?.success(this.isEditingFormulacion ? 'Formulación actualizada' : 'Formulación creada');
        this.cerrarModalFormulacion();
        await this.cargarFormulaciones(this.filaSeleccionada.orden);

      } catch (error) {
        console.error('Error guardando formulación:', error);
        this.$toast?.error(error.response?.data?.message || 'Error al guardar');
      } finally {
        this.isLoading = false;
      }
    },

    eliminarFila(fila) {
      if (this.isVigenciaBloqueada) {
        this.$toast?.error('La vigencia seleccionada está deshabilitada para eliminar');
        return;
      }
      this.elementoAEliminar = fila;
      this.tipoEliminacion = 'fila';
      this.showDeleteModal = true;
    },

    eliminarFormulacion(formulacion) {
      if (this.isVigenciaBloqueada) {
        this.$toast?.error('La vigencia seleccionada está deshabilitada para eliminar');
        return;
      }
      this.elementoAEliminar = formulacion;
      this.tipoEliminacion = 'formulacion';
      this.showDeleteModal = true;
    },

    async confirmarEliminacion() {
      if (this.isVigenciaBloqueada) {
        this.$toast?.error('La vigencia seleccionada está deshabilitada para eliminar');
        return;
      }
      if (!this.elementoAEliminar) return;

      this.isLoading = true;

      try {
        if (this.tipoEliminacion === 'fila') {
          await Balance.eliminarFilaPrincipalOri(this.elementoAEliminar.id);
          this.$toast?.success('Fila eliminada');
          await this.consultarFilas();
        } else {
          await Balance.eliminarFormulacionOri(this.elementoAEliminar.id);
          this.$toast?.success('Formulación eliminada');
          await this.cargarFormulaciones(this.filaSeleccionada.orden);
        }

        this.showDeleteModal = false;
        this.elementoAEliminar = null;
        this.tipoEliminacion = null;

      } catch (error) {
        console.error('Error eliminando:', error);
        this.$toast?.error('Error al eliminar');
      } finally {
        this.isLoading = false;
      }
    },

    async cargarCuentasYNiifs() {
      try {
        const [cuentasRes, niifsRes] = await Promise.all([
          PlanCuentas.planCuentPorCompaVig(this.companyId, this.selVigencia),
          PlanConsolidacion.getPlanConsPorCompVige(this.selVigencia, this.selReporte, this.companyId)
        ]);

        this.cuentasDisponibles = cuentasRes.data.planCuentas || [];
        this.cuentasDisponibles.forEach(c => {
          c._selected = false;
        });
        this.filteredCuentas = [...this.cuentasDisponibles];

        this.niifsDisponibles = (niifsRes.data.planConsNiif || []).map(n => {
          return {
            ...n,
            _selected: false,
            niif: n.niif ? n.niif.toString() : n.niif
          };
        });

        this.filteredNiifs = [...this.niifsDisponibles];
        this.listNiifsDisponibles = [...this.niifsDisponibles];

      } catch (error) {
        console.error('Error cargando cuentas/NIIFs:', error);
      }
    },

    cambiarTipoFormulacion() {
      // Cuando cambia contable, resetear valores
      if (this.formulacionData.contable === '1') {
        // Si es contable, limpiar datos de formulación
        this.formulacionData.cuentasSeleccionadas = [];
        this.formulacionData.formulacion = 'm';
        this.formulacionData.sumFila = '';
        this.formulacionData.sumColumna = '';
        this.formulacionData.celdaFila = '';
        this.formulacionData.celdaColumna = '';
        this.formulacionData.niifFormulacion = [];
        this.selectAllCuentas = false;
      } else {
        // Si es no contable, limpiar cuentas
        this.formulacionData.cuentasSeleccionadas = [];
      }
    },

    cambiarFormulacion() {
      // Resetear campos específicos según el tipo de formulación
      this.formulacionData.sumFila = '';
      this.formulacionData.sumColumna = '';
      this.formulacionData.celdaFila = '';
      this.formulacionData.celdaColumna = '';
      this.formulacionData.niifFormulacion = [];
    },

    filtrarCuentas() {
      if (!this.cuentasSearchTerm) {
        this.filteredCuentas = [...this.cuentasDisponibles];
      } else {
        const term = this.cuentasSearchTerm.toLowerCase();
        this.filteredCuentas = this.cuentasDisponibles.filter(cuenta =>
          (cuenta.cuenta && cuenta.cuenta.toString().toLowerCase().includes(term)) ||
          (cuenta.descripcion && cuenta.descripcion.toLowerCase().includes(term))
        );
      }
      // Mantener el estado _selected en los elementos filtrados
      this.filteredCuentas.forEach(cuenta => {
        cuenta._selected = this.formulacionData.cuentasSeleccionadas.includes(cuenta.cuenta);
      });
      this.updateSelectAllCuentas();
    },

    filtrarNiifs() {
      if (!this.niifsSearchTerm) {
        this.filteredNiifs = [...this.niifsDisponibles];
      } else {
        const term = this.niifsSearchTerm.toLowerCase();
        this.filteredNiifs = this.niifsDisponibles.filter(niif =>
          (niif.niif && niif.niif.toString().toLowerCase().includes(term)) ||
          ((niif.nameNiif || niif.descripcion) && (niif.nameNiif || niif.descripcion).toLowerCase().includes(term)) ||
          (niif.primer_nivel && niif.primer_nivel.toString().toLowerCase().includes(term)) ||
          (niif.segundo_nivel && niif.segundo_nivel.toString().toLowerCase().includes(term)) ||
          (niif.namePrimerNivel && niif.namePrimerNivel.toLowerCase().includes(term)) ||
          (niif.nameSegundoNivel && niif.nameSegundoNivel.toLowerCase().includes(term))
        );
      }

      // Mantener el estado _selected en los elementos filtrados
      this.filteredNiifs.forEach(niif => {
        niif._selected = this.formulacionData.niifFormulacion.includes(niif.niif.toString());
      });

      this.updateSelectAllNiifs();
    },

    onCuentaCheckboxChange(cuenta) {
      if (cuenta._selected) {
        if (!this.formulacionData.cuentasSeleccionadas.includes(cuenta.cuenta)) {
          this.formulacionData.cuentasSeleccionadas.push(cuenta.cuenta);
        }
      } else {
        const index = this.formulacionData.cuentasSeleccionadas.indexOf(cuenta.cuenta);
        if (index > -1) {
          this.formulacionData.cuentasSeleccionadas.splice(index, 1);
        }
      }
      this.updateSelectAllCuentas();
    },

    onNiifCheckboxChange(niif) {
      const niifString = niif.niif.toString();

      if (niif._selected) {
        if (!this.formulacionData.niifFormulacion.includes(niifString)) {
          this.formulacionData.niifFormulacion.push(niifString);
        }
      } else {
        const index = this.formulacionData.niifFormulacion.indexOf(niifString);
        if (index > -1) {
          this.formulacionData.niifFormulacion.splice(index, 1);
        }
      }
      this.updateSelectAllNiifs();
    },
    updateSelectAllCuentas() {
      if (this.filteredCuentas.length === 0) {
        this.selectAllCuentas = false;
        return;
      }
      this.selectAllCuentas = this.filteredCuentas.every(cuenta =>
        this.formulacionData.cuentasSeleccionadas.includes(cuenta.cuenta)
      );
    },

    updateSelectAllNiifs() {
      if (this.filteredNiifs.length === 0) {
        this.selectAllNiifs = false;
        return;
      }

      // Convertir todo a string para comparación consistente
      this.selectAllNiifs = this.filteredNiifs.every(niif =>
        this.formulacionData.niifFormulacion.includes(niif.niif.toString())
      );
    },

    toggleSelectAllCuentas() {
      if (this.selectAllCuentas) {
        // Deseleccionar todas
        this.filteredCuentas.forEach(cuenta => {
          const index = this.formulacionData.cuentasSeleccionadas.indexOf(cuenta.cuenta);
          if (index > -1) {
            this.formulacionData.cuentasSeleccionadas.splice(index, 1);
          }
          cuenta._selected = false;
        });
        this.selectAllCuentas = false;
      } else {
        // Seleccionar todas
        this.filteredCuentas.forEach(cuenta => {
          if (!this.formulacionData.cuentasSeleccionadas.includes(cuenta.cuenta)) {
            this.formulacionData.cuentasSeleccionadas.push(cuenta.cuenta);
          }
          cuenta._selected = true;
        });
        this.selectAllCuentas = true;
      }
    },

    toggleSelectAllNiifs() {
      if (this.selectAllNiifs) {
        // Deseleccionar todas
        this.filteredNiifs.forEach(niif => {
          const niifString = niif.niif.toString();
          const index = this.formulacionData.niifFormulacion.indexOf(niifString);
          if (index > -1) {
            this.formulacionData.niifFormulacion.splice(index, 1);
          }
          niif._selected = false;
        });
        this.selectAllNiifs = false;
      } else {
        // Seleccionar todas
        this.filteredNiifs.forEach(niif => {
          const niifString = niif.niif.toString();
          if (!this.formulacionData.niifFormulacion.includes(niifString)) {
            this.formulacionData.niifFormulacion.push(niifString);
          }
          niif._selected = true;
        });
        this.selectAllNiifs = true;
      }
    },

    getFormulacionTexto(item) {
      if (!item.formulacion) return 'Manual';

      if (item.formulacion.startsWith('sf:')) {
        return `Suma Fila(s): ${item.formulacion.substring(3)}`;
      }
      if (item.formulacion.startsWith('sc:')) {
        return `Suma Columna(s): ${item.formulacion.substring(3)}`;
      }
      if (item.formulacion.startsWith('c:')) {
        const coords = item.formulacion.substring(2);
        return `Celda: ${coords}`;
      }
      if (item.formulacion.startsWith('n:')) {
        return `NIIF: ${item.formulacion.substring(2)}`;
      }
      return 'Manual';
    },

    truncarTexto(texto, longitud) {
      if (!texto) return '-';
      return texto.length > longitud ? texto.substring(0, longitud) + '...' : texto;
    },

    cerrarModalFila() {
      this.showModalFila = false;
      this.filaFormData = {
        id: null,
        orden: null,
        descripcion: ''
      };
    },

    cerrarModalFormulacion() {
      this.showModalFormulacion = false;
      this.formulacionData = {
        id: null,
        orden: null,
        contable: '1',
        actual: '1',
        operacion: '+',
        cuentasSeleccionadas: [],
        formulacion: 'm',
        sumFila: '',
        sumColumna: '',
        celdaFila: '',
        celdaColumna: '',
        niifFormulacion: []
      };
      this.selectAllCuentas = false;
      this.selectAllNiifs = false;
      this.cuentasSearchTerm = '';
      this.niifsSearchTerm = '';
    },

    async cargarDatosIniciales() {
      this.isLoading = true;

      try {
        const [reportesRes, vigenciasRes, gruposRes] = await Promise.all([
          Balance.getReportes(),
          PlanCuentas.getVigenciaPlancuentas(),
          Grupo.getAllGrupos()
        ]);

        this.listReportes = reportesRes.data.reportes || [];
        this.listVigencias = vigenciasRes.data.getVigencia || [];
        this.listGrupos = gruposRes.data.grupos || [];

        await this.cargarCompaniesUsuario();

      } catch (error) {
        console.error('Error cargando datos iniciales:', error);
        this.$toast?.error('Error al cargar datos iniciales');
      } finally {
        this.isLoading = false;
      }
    },

    async cargarCompaniesUsuario() {
      try {
        const userResult = await Balance.leaCompaniaUsuario();
        this.companiaUsuario = userResult.data.companiaUsuario || [];

        const companiesResult = await Company.getAllCompanies();
        const allCompanies = companiesResult.data.companies || [];

        const userRole = this.$store?.state?.userRole || localStorage.getItem('userRole');
        const userId = this.userId || this.$store?.state?.userId || localStorage.getItem('userId');

        const filtered = allCompanies.filter(company => {
          if (userRole == 1) return true;
          return this.companiaUsuario.some(
            uc => uc.id_usuario == userId && uc.id_compania == company.id
          );
        });

        this.listCompanies = filtered;
        this.filteredCompanies = [...filtered];

      } catch (error) {
        console.error('Error cargando compañías:', error);
        this.listCompanies = [];
        this.filteredCompanies = [];
      }
    }
  },

  mounted() {
    this.cargarDatosIniciales();
  }
};
</script>

<style scoped>
.reporte-ecp-container {
  margin-top: 20px;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-4 {
  font-size: 1.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.form-control-lg {
  font-size: 1.25rem;
  padding: 0.5rem 1rem;
  height: auto;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.btn-lg {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.px-5 {
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}

.mx-2 {
  margin-left: 0.5rem !important;
  margin-right: 0.5rem !important;
}

.px-3 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}

.consolidation-section {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  max-width: 800px;
  margin: 0 auto;
}

.companies-checkbox-list {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #ccc;
  padding: 15px;
  border-radius: 5px;
  background-color: white;
}

.fila-item {
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: background-color 0.2s;
}

.fila-item:hover {
  background-color: #f0f7ff;
}

.fila-item.selected-item {
  background-color: #e3f2fd;
}

.balance-table {
  font-size: 14px;
}

.balance-table>>>.md-table-head {
  padding: 8px 4px !important;
}

.balance-table>>>.md-table-cell {
  padding: 8px 4px !important;
  min-width: auto !important;
}

.principal-table>>>.md-table-cell:nth-child(1) {
  width: 100px !important;
  max-width: 100px !important;
}

.principal-table>>>.md-table-cell:nth-child(2) {
  width: 80px !important;
  max-width: 80px !important;
}

.principal-table>>>.md-table-cell:nth-child(3) {
  width: 80px !important;
  max-width: 80px !important;
}

.principal-table>>>.md-table-cell:nth-child(4) {
  width: 250px !important;
  max-width: 250px !important;
  white-space: normal !important;
  word-wrap: break-word !important;
}

.principal-table>>>.md-table-cell:nth-child(5),
.principal-table>>>.md-table-cell:nth-child(6) {
  width: 80px !important;
  max-width: 80px !important;
}

.balance-table>>>.md-table {
  width: 100% !important;
  table-layout: fixed !important;
}

.balance-table>>>.md-table-toolbar {
  min-height: 60px !important;
  padding: 8px 16px !important;
}

.config-dialog>>>.md-dialog,
.formulation-dialog>>>.md-dialog {
  max-width: 800px;
  width: 90%;
}

.dialog-header-create {
  background: #2e507a;
  color: white;
  padding: 15px 20px;
}

.form-container {
  padding: 20px 0;
}

.form-group {
  margin-bottom: 20px;
}

.field-label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
  color: #2c3e50;
}

.field-label.required:after {
  content: '*';
  color: #cd2838;
  margin-left: 4px;
}

.search-box {
  margin-bottom: 12px;
}

.search-box input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
}

.selection-area {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}

.selection-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
}

.selection-count {
  font-size: 12px;
  color: #7f8c8d;
}

.items-list {
  max-height: 200px;
  overflow-y: auto;
  padding: 8px 0;
}

.item-checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px;
  cursor: pointer;
  margin: 0;
  transition: background-color 0.2s;
}

.item-checkbox:hover {
  background-color: #f0f7ff;
}

.item-checkbox input {
  cursor: pointer;
  flex-shrink: 0;
}

.item-checkbox span {
  font-size: 13px;
  color: #34495e;
}

.empty-message {
  text-align: center;
  padding: 30px;
  color: #95a5a6;
}

.text-center {
  text-align: center;
}

/* Estilos para tablas de cuentas y NIIFs */
.search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  gap: 16px;
}

.search-field {
  margin: 0;
  flex: 1;
}

.selection-info {
  color: #6c757d;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
}

.cuenta-table-container,
.niif-table-container {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  margin-top: 8px;
}

.cuenta-table,
.niif-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  font-size: 13px;
}

.cuenta-table thead,
.niif-table thead {
  position: sticky;
  top: 0;
  z-index: 10;
}

.cuenta-table th,
.niif-table th {
  background: #34495e;
  color: white;
  padding: 10px 8px;
  text-align: left;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  border-bottom: 2px solid #2c3e50;
}

.cuenta-table td,
.niif-table td {
  padding: 8px 8px;
  border-bottom: 1px solid #e9ecef;
  vertical-align: middle;
}

.cuenta-table tr:hover,
.niif-table tr:hover {
  background: #f8f9fa;
}

.checkbox-column {
  width: 50px;
  text-align: center;
}

.cuenta-column {
  width: 120px;
  font-weight: 600;
  color: #2c3e50;
}

.niif-column {
  width: 80px;
  font-weight: 600;
  color: #2c3e50;
}

.desc-column {
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.no-results {
  padding: 30px;
  text-align: center;
  color: #95a5a6;
  font-style: italic;
}

/* Estilos para checkboxes personalizados */
.custom-checkbox {
  margin: 0;
}

:deep(.custom-checkbox.md-checked .md-checkbox-container) {
  background: #2e507a !important;
  border-color: #2e507a !important;
}

:deep(.custom-checkbox.md-checked .md-checkbox-container::after) {
  border-color: white !important;
}

:deep(.custom-checkbox .md-checkbox-container) {
  border-radius: 3px;
}

/* Ajustes para el modal de formulación */
.formulation-dialog>>>.md-dialog {
  max-width: 900px;
  width: 90%;
}

.formulation-dialog>>>.md-dialog-content {
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
}

/* Scroll personalizado para tablas */
.cuenta-table-container::-webkit-scrollbar,
.niif-table-container::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.cuenta-table-container::-webkit-scrollbar-track,
.niif-table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.cuenta-table-container::-webkit-scrollbar-thumb,
.niif-table-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.cuenta-table-container::-webkit-scrollbar-thumb:hover,
.niif-table-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Responsive */
@media (max-width: 768px) {
  .search-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .selection-info {
    text-align: right;
  }

  .cuenta-column,
  .niif-column {
    width: auto;
  }

  .desc-column {
    max-width: 150px;
  }
}
</style>
